import { TSuggest } from 'feature/registration/types'
import { IconButton, InputAdornment, TextField } from 'ui'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { TextFieldProps } from '@mui/material'
import { ScreenEnum, useScreen } from 'feature/screenMode'

type Props = {
  inputProps: TextFieldProps
  removeValue: () => void
  addressValue: TSuggest
}

export function DadataSelectedField({
  inputProps,
  removeValue,
  addressValue,
}: Props) {
  const screen = useScreen()

  const {
    required,
    InputProps: inputPropsInputProps,
    ...textFieldProps
  } = inputProps

  const computedTextFieldProps = {
    ...textFieldProps,
    multiline: textFieldProps.multiline ?? true,
    maxRows: textFieldProps.maxRows ?? (screen !== ScreenEnum.desktop ? 10 : 2),
  }

  return (
    <TextField
      {...computedTextFieldProps}
      value={addressValue.address}
      disabled
      fullWidth
      sx={{
        mb: 1,
        '& .MuiOutlinedInput-root.Mui-disabled': {
          borderRadius: '12px !important',
          '& fieldset': {
            borderStyle: 'solid !important',
            borderColor: 'rgba(0, 0, 0, 0.23) !important',
          },
          '&:hover fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.23) !important',
          },
        },
        '& .MuiInputBase-input.Mui-disabled': {
          WebkitTextFillColor: 'inherit !important',
          color: 'inherit !important',
          cursor: 'default',
        },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              aria-label='удалить адрес'
              onClick={removeValue}
              edge='end'
              size='small'
              sx={{ mr: -1 }}
            >
              <DeleteOutlineIcon fontSize='small' />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}
